/**
 * Store Locator Map - Marker Click Zoom Functionality
 * Forceert zoom wanneer de map center verandert (marker click)
 */

(function() {
  'use strict';

  const ZOOM_LEVEL = 16;  // Zoom level bij marker click (10-20)
  const ZOOM_DELAY = 100; // Delay voor zoom (ms)
  const DEBUG = false;     // Debug logging aan/uit

  let mapInstance = null;
  let lastCenter = null;
  let isZooming = false;
  let allMarkers = [];
  let isInitializing = true;  // Voorkom auto-zoom tijdens init

  function log() {
    if (DEBUG && console && console.log) {
      console.log.apply(console, ['[Store Zoom]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  /**
   * Probeert alle map elementen te vinden via Google Maps data in DOM
   */
  function findMapInDOM() {
    // Zoek alle mogelijke map containers
    const selectors = [
      '[class*="gm-style"]',
      '[class*="map"]',
      '[id*="map"]',
      'div[style*="position: relative"]'
    ];

    for (let i = 0; i < selectors.length; i++) {
      const elements = document.querySelectorAll(selectors[i]);
      for (let j = 0; j < elements.length; j++) {
        const el = elements[j];

        // Check of dit element een Google Maps div is
        if (el.querySelector('.gm-style') || el.classList.contains('gm-style')) {
          // Probeer map instance te vinden via element properties
          for (let key in el) {
            try {
              if (key.startsWith('__') && el[key]) {
                // React of andere framework property
                continue;
              }
            } catch (e) {
              continue;
            }
          }

          log('Map container gevonden:', el);
          return el;
        }
      }
    }

    return null;
  }

  /**
   * Zoekt Google Maps instantie in window object
   */
  function findMapInstance() {
    if (!window.google || !window.google.maps || !window.google.maps.Map) {
      return null;
    }

    // Methode 1: Zoek in window scope
    for (let key in window) {
      try {
        const obj = window[key];
        if (obj && typeof obj === 'object') {
          // Check of dit een Map instance is
          if (obj instanceof window.google.maps.Map) {
            log('Map instance gevonden via window.' + key);
            return obj;
          }

          // Check nested objects
          if (obj.map && obj.map instanceof window.google.maps.Map) {
            log('Map instance gevonden via window.' + key + '.map');
            return obj.map;
          }
        }
      } catch (e) {
        // Skip restricted properties
        continue;
      }
    }

    // Methode 2: Zoek via DOM element __gm property
    const mapContainer = findMapInDOM();
    if (mapContainer) {
      try {
        // Google Maps slaat vaak data op in __gm property
        const gmData = mapContainer.__gm;
        if (gmData && gmData.map) {
          log('Map instance gevonden via DOM __gm property');
          return gmData.map;
        }
      } catch (e) {
        // Skip
      }
    }

    return null;
  }

  /**
   * Forceert zoom op de map
   */
  function forceZoom(map) {
    if (!map || isZooming) return;

    isZooming = true;

    try {
      const currentZoom = map.getZoom ? map.getZoom() : null;
      log('Huidige zoom level:', currentZoom, '→ Nieuwe zoom:', ZOOM_LEVEL);

      if (map.setZoom && typeof map.setZoom === 'function') {
        map.setZoom(ZOOM_LEVEL);
        log('✓ Zoom ingesteld op', ZOOM_LEVEL);

        // Dubbel check na korte delay
        setTimeout(function() {
          if (map.getZoom && map.getZoom() !== ZOOM_LEVEL) {
            log('⚠ Zoom werd teruggezet, force opnieuw...');
            map.setZoom(ZOOM_LEVEL);
          }
          isZooming = false;
        }, 50);
      } else {
        log('✗ setZoom functie niet beschikbaar');
        isZooming = false;
      }
    } catch (e) {
      log('✗ Error bij zoomen:', e);
      isZooming = false;
    }
  }

  /**
   * Monitort center veranderingen van de map
   */
  function monitorCenterChanges(map) {
    if (!map || !window.google || !window.google.maps) return;

    try {
      // Luister naar center_changed event
      window.google.maps.event.addListener(map, 'center_changed', function() {
        // Skip auto-zoom tijdens initialisatie
        if (isInitializing) {
          log('Center changed tijdens init, skip auto-zoom');
          return;
        }

        const newCenter = map.getCenter();

        // Als center veranderd is, zoom dan in
        if (newCenter && (!lastCenter ||
            !lastCenter.equals ||
            !lastCenter.equals(newCenter))) {

          log('Map center veranderd, zooming in...');

          // Wacht kort om te zorgen dat center update klaar is
          setTimeout(function() {
            forceZoom(map);
          }, 100);

          lastCenter = newCenter;
        }
      });

      log('✓ Center change monitor geactiveerd');
    } catch (e) {
      log('✗ Kon center monitor niet activeren:', e);
    }
  }

  /**
   * Voegt click listeners toe aan DOM
   */
  function addClickListeners(map) {
    log('Voeg click listeners toe...');

    // Luister naar alle clicks op de pagina
    document.addEventListener('click', function(event) {
      const target = event.target;

      // Check 1: Marker image
      if (target.tagName === 'IMG' && target.src &&
          (target.src.includes('marker') || target.src.includes('pin'))) {
        log('Marker image clicked');
        setTimeout(function() { forceZoom(map); }, ZOOM_DELAY);
        return;
      }

      // Check 2: Clickable element binnen map
      const mapContainer = target.closest('.gm-style, [class*="map"]');
      if (mapContainer) {
        const style = window.getComputedStyle(target);
        if (style.cursor === 'pointer') {
          log('Pointer element in map clicked');
          setTimeout(function() { forceZoom(map); }, ZOOM_DELAY);
          return;
        }
      }

      // Check 3: VIEW ON MAP button
      const text = target.textContent || '';
      if (text.includes('VIEW ON MAP') || text.includes('BEKIJK OP KAART')) {
        log('Sidebar button clicked');
        setTimeout(function() { forceZoom(map); }, 200);
        return;
      }

      // Check 4: Address list item
      const addressItem = target.closest('li, [class*="address"], [class*="store"]');
      if (addressItem) {
        log('Address item clicked');
        setTimeout(function() { forceZoom(map); }, 200);
      }
    }, true);

    log('✓ Click listeners toegevoegd');
  }

  /**
   * Intercepteert Google Maps Marker constructor
   */
  function interceptMarkers() {
    if (!window.google || !window.google.maps || !window.google.maps.Marker) {
      return false;
    }

    try {
      const OriginalMarker = window.google.maps.Marker;

      window.google.maps.Marker = function(opts) {
        const marker = new OriginalMarker(opts);

        // Bewaar marker in array
        allMarkers.push(marker);
        log('Marker toegevoegd, totaal:', allMarkers.length);

        // Voeg click listener toe
        try {
          marker.addListener('click', function() {
            log('Marker clicked via interceptie');
            const map = marker.getMap();
            if (map) {
              setTimeout(function() { forceZoom(map); }, ZOOM_DELAY);
            }
          });
        } catch (e) {
          log('Kon click listener niet toevoegen aan marker:', e);
        }

        return marker;
      };

      // Kopieer prototype
      window.google.maps.Marker.prototype = OriginalMarker.prototype;
      Object.setPrototypeOf(window.google.maps.Marker, OriginalMarker);

      log('✓ Marker interceptie geactiveerd');
      return true;
    } catch (e) {
      log('✗ Marker interceptie gefaald:', e);
      return false;
    }
  }

  /**
   * Zoekt alle markers op de map en fit de bounds
   */
  function fitMapToMarkers(map) {
    if (!map || !window.google || !window.google.maps) return;

    log('Zoeken naar markers om bounds te fitten...');

    // Wacht even tot markers geladen zijn
    setTimeout(function() {
      try {
        const bounds = new window.google.maps.LatLngBounds();
        let markerCount = 0;

        // Methode 1: Gebruik onze tracked markers
        if (allMarkers.length > 0) {
          log('Gebruik tracked markers:', allMarkers.length);
          allMarkers.forEach(function(marker) {
            try {
              const pos = marker.getPosition();
              if (pos) {
                bounds.extend(pos);
                markerCount++;
              }
            } catch (e) {
              // Skip invalid markers
            }
          });
        }

        // Methode 2: Zoek markers via window scope (fallback)
        if (markerCount === 0) {
          log('Fallback: zoek markers via window scope...');
          for (let key in window) {
            try {
              const obj = window[key];
              if (obj && Array.isArray(obj)) {
                obj.forEach(function(item) {
                  if (item && item instanceof window.google.maps.Marker) {
                    const pos = item.getPosition();
                    if (pos) {
                      bounds.extend(pos);
                      markerCount++;
                    }
                  }
                });
              }
            } catch (e) {
              continue;
            }
          }
        }

        // Als we markers hebben gevonden, fit de bounds
        if (markerCount > 0) {
          log('✓ ' + markerCount + ' markers gevonden, fitting bounds...');
          map.fitBounds(bounds);

          // Na fitBounds, check zoom level en zet max zoom als te ver ingezoomd
          setTimeout(function() {
            const currentZoom = map.getZoom();
            if (currentZoom > 12) {
              log('Zoom te hoog (' + currentZoom + '), beperken tot 12');
              map.setZoom(12);
            }

            // Initialisatie is klaar, activeer auto-zoom voor marker clicks
            setTimeout(function() {
              isInitializing = false;
              log('✓ Initialisatie voltooid, auto-zoom geactiveerd');
            }, 500);
          }, 500);
        } else {
          log('⚠ Geen markers gevonden, probeer later opnieuw...');
          // Probeer opnieuw na 2 seconden (max 3x)
          if (!fitMapToMarkers.retryCount) fitMapToMarkers.retryCount = 0;
          if (fitMapToMarkers.retryCount < 3) {
            fitMapToMarkers.retryCount++;
            setTimeout(function() {
              fitMapToMarkers(map);
            }, 2000);
          } else {
            // Als na 3 retries geen markers, activeer auto-zoom alsnog
            isInitializing = false;
            log('⚠ Geen markers gevonden na retries, auto-zoom geactiveerd');
          }
        }
      } catch (e) {
        log('✗ Error bij fitBounds:', e);
      }
    }, 1000);
  }

  /**
   * Hoofdinitialisatie
   */
  function initialize() {
    log('Initialiseren zoom functionaliteit...');

    // Wacht tot Google Maps beschikbaar is
    let attempts = 0;
    const maxAttempts = 100;
    let markerInterceptionEnabled = false;

    const initInterval = setInterval(function() {
      attempts++;

      // Check of Google Maps beschikbaar is
      if (!window.google || !window.google.maps) {
        if (attempts >= maxAttempts) {
          log('✗ Google Maps niet gevonden na', attempts, 'pogingen');
          clearInterval(initInterval);
        }
        return;
      }

      // Activeer marker interceptie zo snel mogelijk (voor markers worden gemaakt)
      if (!markerInterceptionEnabled && window.google.maps.Marker) {
        interceptMarkers();
        markerInterceptionEnabled = true;
      }

      // Probeer map instance te vinden
      const map = findMapInstance();

      if (map) {
        log('✓ Map instance gevonden!');
        mapInstance = map;

        // Activeer alle methodes
        monitorCenterChanges(map);
        addClickListeners(map);

        // Fit map naar alle markers bij start
        fitMapToMarkers(map);

        clearInterval(initInterval);
        log('✓ Zoom functionaliteit volledig geactiveerd');
      } else if (attempts >= maxAttempts) {
        log('✗ Map instance niet gevonden na', attempts, 'pogingen');
        log('   Probeer alleen click listeners (fallback)...');

        // Fallback: probeer later opnieuw
        setTimeout(function() {
          const retryMap = findMapInstance();
          if (retryMap) {
            log('✓ Map gevonden bij retry!');
            mapInstance = retryMap;
            monitorCenterChanges(retryMap);
            addClickListeners(retryMap);
            fitMapToMarkers(retryMap);
          }
        }, 2000);

        clearInterval(initInterval);
      }
    }, 100);
  }

  // Start direct
  log('Script geladen');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();
